import {PublicationsFilter} from '../PublicationsFilter';
import {PublicationListItem} from '../PublicationListItem';
import {PublicationsPagination} from '../PublicationsPagination';

export interface PublicationsTypePageData {
  items: Research.PublicPublicationDto[];
  total: number;
  page: number;
  totalPages: number;
}

export interface PublicationsTypePageProps {
  data: PublicationsTypePageData;
  basePath: string;
  streams: Array<{slug: string; name: string}>;
}

export function PublicationsTypePage({data, basePath, streams}: PublicationsTypePageProps) {
  return (
    <>
      <PublicationsFilter
        streams={streams}
        basePath={basePath}
        hideTypeFilter
      />

      {data.items.length > 0 ? (
        <ul role="list" className="flex flex-col gap-2">
          {data.items.map((publication) => (
            <PublicationListItem key={publication.id} publication={publication} />
          ))}
        </ul>
      ) : (
        <div className="text-center py-8">
          <p className="text-shade-11">Nenhuma publicação encontrada com os filtros aplicados.</p>
        </div>
      )}

      <PublicationsPagination
        currentPage={data.page}
        totalPages={data.totalPages}
        total={data.total}
      />
    </>
  );
}
